import React, { useCallback, useState } from "react";
import { connect } from "react-redux";

import { getCurrentUser, logOut } from "../../../../store/utils/helpers";
import { getKey, hasKey, hasUserFeaturesEnable } from "../../../utils/helpers";

import ArrowTooltip from "./ButtonTooltip";

import {
  ContentLoginButton,
  Icon,
  IconButton,
  Span,
  Link,
  WrapperUserImage
} from "./Button";

// `user` arrives through connect (the store of the current request) instead of
// reading the shared store directly, which on the server belongs to the whole
// node process and would render another visitor's session.
function ButtonLogin({ user }) {
  const [toolTipOpen, setToolTipOpen] = useState(false);

  function handleTooltipClose() {
    setToolTipOpen(false);
  }

  function handleTooltipOpen() {
    setToolTipOpen(!toolTipOpen);
  }
  const goLoginPage = useCallback(() => {
    window.location.href = `/login?ref=${window.location.pathname}`;
  });
  return !hasUserFeaturesEnable() ? null : (
    <ContentLoginButton>
      <Link onClick={user === null ? goLoginPage : handleTooltipOpen}>
        {user === null ? (
          <IconButton name="userCircle" iconSize={22} />
        ) : (
          <WrapperUserImage>
            <ArrowTooltip
              title={
                <ul>
                  <li>
                    <Link href="/mi-perfil">
                      <Icon name="User" size={16} />
                      <span>Mi perfil</span>
                    </Link>
                  </li>
                  <li>
                    <Link href="/mi-lista">
                      <Icon name="ListUl" size={16} />
                      <span>Mi lista</span>
                    </Link>
                  </li>
                  <li>
                    <Link onClick={logOut}>
                      <Icon name="Close" size={16} />
                      <span>Cerrar Sesión</span>
                    </Link>
                  </li>
                </ul>
              }
              open={toolTipOpen}
              onClose={handleTooltipClose}
            >
              {hasKey(user, "image.picture.path") ? (
                <img alt="Imagen de usuario" src={user.image.picture.path} />
              ) : hasKey(user, "image_social") ? (
                <img alt="Imagen social" src={user.image_social} />
              ) : (
                <IconButton name="userCircle" iconSize={22} />
              )}
            </ArrowTooltip>
          </WrapperUserImage>
        )}
        <Span>
          {user === null
            ? "Iniciar Sesión"
            : getKey(user, "full_name") || getKey(user, "mail")}
        </Span>
      </Link>
    </ContentLoginButton>
  );
}

const mapStateToProps = state => ({
  user: getCurrentUser(state)
});

export default connect(mapStateToProps)(ButtonLogin);
